module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//11.jpg?476b75bfff90d15e7c07091dc2c445f1";